/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseCodeInterpreterCallCompletedEvent = {
  type: "response.code_interpreter_call.completed";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseCodeInterpreterCallCompletedEvent$inboundSchema: z.ZodType<
  ResponseCodeInterpreterCallCompletedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.code_interpreter_call.completed"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseCodeInterpreterCallCompletedEvent$Outbound = {
  type: "response.code_interpreter_call.completed";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseCodeInterpreterCallCompletedEvent$outboundSchema:
  z.ZodType<
    ResponseCodeInterpreterCallCompletedEvent$Outbound,
    z.ZodTypeDef,
    ResponseCodeInterpreterCallCompletedEvent
  > = z.object({
    type: z.literal("response.code_interpreter_call.completed"),
    sequenceNumber: z.number().int(),
    itemId: z.string(),
    outputIndex: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      sequenceNumber: "sequence_number",
      itemId: "item_id",
      outputIndex: "output_index",
    });
  });

export function responseCodeInterpreterCallCompletedEventToJSON(
  responseCodeInterpreterCallCompletedEvent:
    ResponseCodeInterpreterCallCompletedEvent,
): string {
  return JSON.stringify(
    ResponseCodeInterpreterCallCompletedEvent$outboundSchema.parse(
      responseCodeInterpreterCallCompletedEvent,
    ),
  );
}
export function responseCodeInterpreterCallCompletedEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseCodeInterpreterCallCompletedEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseCodeInterpreterCallCompletedEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseCodeInterpreterCallCompletedEvent' from JSON`,
  );
}
